module.exports = __webpack_public_path__ + "static/media/sumeyye.d4dd5c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/sumeyye.jpg
// module id = 247
// module chunks = 0